import { MedicationResponse } from "@tellescope/types-models";

export const EMPTY_MEDICATION: MedicationResponse = {
  displayTerm: "",
  drugName: "",
};
